<template>
	<div
		class="fixed inset-y-0 right-0 flex side-over z-50"
		style="width: 720px; max-width: 100%"
	>
		<div
			class="
				h-full
				w-full
				flex flex-col
				bg-white
				shadow-xl
				overflow-y-auto
			"
		>
			<div class="px-6 py-8 bg-blue-50">
				<div class="flex items-start justify-between">
					<div class="flex items-center">
						<svg
							fill="none"
							height="24"
							viewBox="0 0 24 24"
							width="24"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								clip-rule="evenodd"
								d="M6 0.75C6 0.335786 5.66421 0 5.25 0C4.83579 0 4.5 0.335786 4.5 0.75V1.5H3C1.34315 1.5 0 2.84315 0 4.5V6H24V4.5C24 2.84315 22.6569 1.5 21 1.5H19.5V0.75C19.5 0.335786 19.1642 0 18.75 0C18.3358 0 18 0.335786 18 0.75V1.5H6V0.75ZM24 21V7.5H0V21C0 22.6569 1.34315 24 3 24H21C22.6569 24 24 22.6569 24 21ZM12.75 12.75C12.75 12.3358 12.4142 12 12 12C11.5858 12 11.25 12.3358 11.25 12.75V15H9C8.58579 15 8.25 15.3358 8.25 15.75C8.25 16.1642 8.58579 16.5 9 16.5H11.25V18.75C11.25 19.1642 11.5858 19.5 12 19.5C12.4142 19.5 12.75 19.1642 12.75 18.75V16.5H15C15.4142 16.5 15.75 16.1642 15.75 15.75C15.75 15.3358 15.4142 15 15 15H12.75V12.75Z"
								fill="#94A3B8"
								fill-rule="evenodd"
							/>
						</svg>
						<div
							class="text-xl font-bold text-neutral-700 ml-2 mt-1"
						>
							Chọn học sinh để chỉnh sửa thời khoá biểu
						</div>
					</div>
					<button
						class="rounded-md text-neutral-400 hover:text-neutral-700"
						type="button"
						@click="$emit('close')"
					>
						<span class="sr-only">Đóng</span>
						<svg
							aria-hidden="true"
							class="h-6 w-6"
							fill="none"
							stroke="currentColor"
							viewBox="0 0 24 24"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M6 18L18 6M6 6l12 12"
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
							/>
						</svg>
					</button>
				</div>
			</div>
			<div class="relative flex-1 px-6 pb-20 mt-8">
				<div class="font-semibold text-neutral-600">Chọn học sinh*</div>
				<div class="w-full mt-2">
					<Multiselect
						v-model="studentSelected"
						:allow-empty="false"
						:max-height="300"
						:options="studentOptions"
						:searchable="true"
						deselect-label="Đã chọn"
						label="nameSearch"
						placeholder="Tìm theo tên học sinh"
						select-label=""
						track-by="id"
					>
						<template #noResult>Không tìm thấy kết quả</template>
						<template #option="props">
							<div>{{ props.option.name }}</div>
						</template>
						<template #singleLabel="{ option }">
							<div>{{ option.name }}</div>
						</template>
					</Multiselect>
				</div>
				<div v-if="studentSelected" class="mt-4 flex items-center">
					<img
						v-if="studentSelected.profile_photo?.w200"
						:src="studentSelected.profile_photo.w200"
						alt=""
						class="h-8 w-8 rounded-full"
					/>
					<span
						v-else
						:style="{
							background:
								studentSelected.profile_photo?.default?.color,
						}"
						class="
							inline-flex
							items-center
							justify-center
							h-8
							w-8
							rounded-full
						"
					>
						<span class="font-medium leading-none text-white text-xs">{{
							studentSelected.profile_photo?.default?.initial
						}}</span>
					</span>
					<div class="ml-3 font-semibold text-orange-600">
						{{ studentSelected.name }}
					</div>
				</div>
				<div v-if="studentSelected && !isLoading" class="mt-8">
					<div class="font-semibold text-neutral-600">
						{{ $filters.terminology('teacher') }}
					</div>
					<div
						v-if="!staffs.length"
						class="mt-3 text-neutral-400"
					>
						Chưa có {{ $filters.terminology('teacher') }}. Thêm
						{{ $filters.terminology('teacher') }} để tiếp tục.
					</div>
					<div
						v-for="(staff, index) in staffs"
						:key="staff?.staff?.id || index"
						class="mt-3 flex items-center"
					>
						<img
							v-if="staffAvatar(staff)"
							:src="staffAvatar(staff)"
							alt=""
							class="h-6 w-6 rounded-full"
						/>
						<span
							v-else
							:style="{
								background:
									staff?.staff?.profile_photo?.default?.color,
							}"
							class="
								inline-flex
								items-center
								justify-center
								h-6
								w-6
								rounded-full
							"
						>
							<span
								class="
									font-medium
									leading-none
									text-white text-xs
								"
								>{{
									staff?.staff?.profile_photo?.default
										?.initial
								}}</span
							>
						</span>
						<div class="ml-4 text-blue-600 font-semibold">
							{{ staff?.staff?.name }}
						</div>
					</div>
					<button
						class="button-p btn--text w-fit mt-4"
						type="button"
						@click="
							$router.push(
								`/record/student/${studentSelected.id}/staff-list`
							)
						"
					>
						Thêm {{ $filters.terminology('teacher') }}
					</button>
				</div>
			</div>
			<div
				class="px-6 py-4 border-t border-yellow-50 flex justify-end"
			>
				<button
					:disabled="!studentSelected"
					class="button-p text-center w-32"
					type="button"
					@click="$emit('submit', studentSelected)"
				>
					Tiếp tục
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import { defineComponent } from 'vue';
import Multiselect from '@suadelabs/vue3-multiselect';
import { $api } from '@/services';
import { toEnglish } from '@/helper/toEnglish';

export default defineComponent({
	name: 'ChooseDaycareStudent',
	components: { Multiselect },
	props: {
		open: {
			type: Boolean,
			default: false,
		},
		students: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			studentSelected: null,
			staffs: [],
			isLoading: false,
		};
	},
	computed: {
		studentOptions() {
			return (this.students || []).map((student) => ({
				...student,
				nameSearch: toEnglish(student?.name),
			}));
		},
		isAdmin() {
			return this.$store.getters.isAdmin;
		},
	},
	watch: {
		open(value) {
			if (!value) return;
			this.studentSelected = null;
			this.staffs = [];
		},
		studentSelected: {
			deep: true,
			async handler(value) {
				this.staffs = [];
				if (!value?.id) return;
				await this.fetchAssignment(value.id);
			},
		},
	},
	methods: {
		staffAvatar(staff) {
			return (
				staff?.profile_photo?.w200 || staff?.staff?.profile_photo?.w200
			);
		},
		async fetchAssignment(id) {
			this.isLoading = true;
			try {
				const { data } = await $api.assignment.getAssignments(
					id,
					this.isAdmin
				);
				this.staffs = data?.data || [];
			} catch (err) {
				this.staffs = [];
			} finally {
				this.isLoading = false;
			}
		},
	},
});
</script>
